<ng-lottie [options]="options"></ng-lottie>
